;(function() {
  'use strict'

  angular.module('core.gSelect', [])
})()
